/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */
/**
 * Identifiers of commands registered by shortcuts UI.
 */
export var CommandIDs;
(function (CommandIDs) {
    CommandIDs.editBinding = 'shortcuts:edit-keybinding';
    CommandIDs.addBinding = 'shortcuts:add-keybinding';
    CommandIDs.deleteBinding = 'shortcuts:delete-keybinding';
    CommandIDs.toggleSelectors = 'shortcuts:toggle-selectors';
    CommandIDs.resetAll = 'shortcuts:reset-all';
})(CommandIDs || (CommandIDs = {}));
//# sourceMappingURL=types.js.map